var $ = jQuery.noConflict();
$(document).ready(function () {
  $('.enumenu_ul').responsiveMenu({
    'menuIcon_text': 'Menu',
    onMenuopen: function () {}
  });
  
  /*banner slider*/
  if($('.home-slider').length){
    $('.home-slider').owlCarousel({
      loop:true,
      items:1,    
      nav:true,
      dots: false,   
    });
  }

  $(document).on("click",'.faq-tab a', function(){
    $(".faq-tab-contain-text").slideUp();
    $(this).siblings(".faq-tab-contain-text").stop().slideToggle();
    if($(this).hasClass("active")){
      $(this).removeClass("active");
    }
    else{
      $(".faq-tab a").removeClass("active");
      $(this).addClass("active");
    }
  });
  
  // equal height
  $(".bc-sf-filter-product-item .bc-sf-filter-product-item-title").equalHeight();
  $(".collectionproductdescription .short").equalHeight();
  
  //object fit banner slider image
  var userAgent, ieReg, ie;
  userAgent = window.navigator.userAgent;
  ieReg = /msie|Trident.*rv[ :]*11\./gi;
  ie = ieReg.test(userAgent);

  if(ie) {
    $(".home-slide-img").each(function () {
      var $container = $(this),
          imgUrl = $container.find("img").prop("src");
      if (imgUrl) {
        $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("custom-object-fit");
      }
    });
  }
  
  
  //mobile menu right
  $(".mob-right-menu img").click(function(){
    $(".cart-menu-mob .cart-menu").slideToggle("slow");
  });
  
  $(".menu-box").click(function(){
    $(".cart-menu-mob .cart-menu").slideUp("slow");
  });
  
});  



// equal height
;(function($){
$.fn.equalHeight = function (option) {
var $this = this
var get_height = function(){
var maxheight=0;
$this.css("height","")
$this.each(function(){
maxheight = $(this).height() > maxheight ? $(this).height() : maxheight;
})
$this.height(maxheight)
}
var init =function(){
get_height()
$(window).bind("resize",get_height)
}
$this.destroy = function(){
$this.css("height","")
$(window).unbind("resize",get_height)
}
init()
return this
} 
})(jQuery)